import React, { useEffect } from 'react';
import { useDispatch } from 'umi';
import { EntityViewServiceRequestList } from '@/components/Lead/LeadDetailsServiceRequests';
import { LeadDetailsModel } from '@/typings/models/Lead';

export interface AppointmentsDrawerProps {
  leadId: string;
  leadDetails: LeadDetailsModel;
  onRefresh?: () => void;
  payload?: { mode?: string; [key: string]: any };
}

/**
 * Appointments drawer that displays service requests with filtering capabilities
 * Reuses the existing EntityViewServiceRequestList component for consistency
 */
const AppointmentsDrawer: React.FC<AppointmentsDrawerProps> = ({
  leadDetails,
  onRefresh,
  payload
}) => {
  const dispatch = useDispatch();

  // Combine service_requests and calendarEvents
  const events = (leadDetails?.service_requests || []).concat(
    (leadDetails?.calendarEvents || [] as any).map(event => ({
      ...event,
      blocker: true
    }))
  );

  const handleRequest = () => {
    if (onRefresh) {
      onRefresh();
    }
  };


  return (
    <EntityViewServiceRequestList
      leadDetails={leadDetails}
      events={events}
      request={handleRequest}
      addDisabled={false}
      listView
    />
  );
};

export default AppointmentsDrawer;
